module.exports = __webpack_public_path__ + "media/images/gift/gift-campaign-7d829610981849c240756f60e7d9a5f6.png";